/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Stronger Memory API
 * Lean companion API. OnEarly Core is the system of record.
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const GroupMemberSummary = zod
  .object({
    currentStreak: zod.int(),
    bestStreak: zod.int(),
    sessionsThisMonth: zod.int(),
    sessionsTotal: zod.int().nullable(),
    completionByKind: zod.object({
      read: zod.int(),
      write: zod.int(),
      math: zod.int(),
    }),
    asOf: zod.iso.date(),
  })
  .nullable()
  .describe("The numbers of the member's newest summary");

export type GroupMemberSummary = zod.input<typeof GroupMemberSummary>;
export type GroupMemberSummaryOutput = zod.output<typeof GroupMemberSummary>;
